import { isUndefined, omitBy } from 'lodash';

const omitUndefinedProps = params => omitBy(params, isUndefined);

export default omitUndefinedProps;
